(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hazel-testimonials"] && !Shopify.designMode) return;
  try {
    
  class HazelTestimonials extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.viewport = this.querySelector('.hz-tst__viewport');
      this.rtl = getComputedStyle(this).direction === 'rtl';
      this.slides = Array.from(this.track.children);
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.index = 0;

      this.dots.forEach((d) =>
        d.addEventListener('click', () => this.go(parseInt(d.dataset.dot, 10)))
      );
      if (this.prev) this.prev.addEventListener('click', () => this.go(this.index - 1));
      if (this.next) this.next.addEventListener('click', () => this.go(this.index + 1));

      this.startX = null;
      this.addEventListener('pointerdown', (e) => { this.startX = e.clientX; });
      this.addEventListener('pointerup', (e) => {
        if (this.startX === null) return;
        const dx = e.clientX - this.startX;
        if (Math.abs(dx) > 40) { var fwd = this.rtl ? dx > 0 : dx < 0; this.go(this.index + (fwd ? 1 : -1)); }
        this.startX = null;
      });
      this.addEventListener('pointercancel', () => { this.startX = null; });

      this.go(0);

      // the viewport hugs the active card, so the nav row never floats below
      // a shorter slide; re-sync once media has loaded and on resize
      window.addEventListener('load', () => this.fit());
      window.addEventListener('resize', () => this.fit());
      this.querySelectorAll('img').forEach((img) => img.addEventListener('load', () => this.fit()));
    }

    fit() {
      if (!this.viewport) return;
      const card = this.slides[this.index] && this.slides[this.index].firstElementChild;
      if (card) this.viewport.style.height = card.offsetHeight + 'px';
    }

    go(i) {
      // page by real slide width so multi-per-view desktop never over-scrolls
      const slideW = this.slides[0].getBoundingClientRect().width || this.offsetWidth;
      const perView = Math.max(1, Math.round((this.viewport ? this.viewport.clientWidth : this.offsetWidth) / slideW));
      const max = Math.max(0, this.slides.length - perView);
      this.index = Math.max(0, Math.min(i, max));
      this.track.style.transform = 'translateX(' + this.index * (this.rtl ? 1 : -1) * slideW + 'px)';
      this.dots.forEach((d, n) => {
        if (n === this.index) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      if (this.prev) this.prev.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index >= max;
      this.fit();
    }
  }

  if (!customElements.get('hazel-testimonials')) {
    customElements.define('hazel-testimonials', HazelTestimonials);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
